export const paymentError = method =>
  `An unexpected error occurred with ${method}. Please refresh and try again.`;
export const reauthenticatePaymentError = method => `Please authenticate with ${method} again.`;

export const PREPAID_CARD_ERROR_MESSAGE =
  'Home Chef does not accept prepaid cards. Please use another payment method.';
export const PREPAID_CARD_FUNDING = 'prepaid';
export const DENIED_CARD_COUNTRIES = ['BH', 'IN'];
export const DENIED_CARD_COUNTRY_ERROR_MESSAGE =
  'This payment method is not supported. Please try a different card.';
export const GENERIC_ERROR_MESSAGE =
  'An error has occurred. Please refresh the page and try again or contact support if the error persists.';
export const STRIPE_NOT_INITIALIZED_ERROR_MESSAGE =
  'Stripe has not initialized yet. Please refresh the page and try again.';
export const STRIPE_PAYMENT_METHOD_CREATION_ERROR_MESSAGE = 'Unable to create payment method.';

export const paymentMethodCardErrorMessage = paymentMethod => {
  const card = paymentMethod?.card;
  const cardCountry = card?.country?.toUpperCase();

  if (card?.funding === PREPAID_CARD_FUNDING) {
    return PREPAID_CARD_ERROR_MESSAGE;
  }
  if (DENIED_CARD_COUNTRIES.includes(cardCountry)) {
    return DENIED_CARD_COUNTRY_ERROR_MESSAGE;
  }
  return null;
};
